export const GET_VENDOR_DASHBOARD_REQUEST = "get_vendor_dashboard_request";
export const GET_VENDOR_DASHBOARD_SUCCESS = "get_vendor_dashboard_success";
export const GET_VENDOR_DASHBOARD_FAILURE = "get_vendor_dashboard_failure";
